import { React, Fragment, useState } from "react";
import { Disclosure, Menu, Transition, Dialog } from "@headlessui/react";
import { Link } from "react-router-dom";
import {
  MagnifyingGlassIcon,
  ShoppingBagIcon,
} from "@heroicons/react/24/outline";
import { useGetRequest, sendPostRequest, sendGetRequest } from "../Client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { Notyf } from "notyf";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
import { imageURL } from "../config";

function Navbar() {
  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  const sumChargeTotal = () => {
    let total = 0;

    basket?.basket?.forEach((a) => {
      // total += Number(a.quantity * a.unitPrice);

      if (a.price2 > 0) {
        total += Number(a.quantity * a.unitPrice) + Number(a.price2);
      } else {
        total += Number(a.quantity * a.unitPrice);
      }
    });

    return (Math.round(total * 100) / 100).toFixed(2);
  };

  // confirmation notifications
  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
  });

  const deletedNotyf = () => {
    notyf.success({ message: "Basket item deleted", background: "#dec616" });
  };

  // loading basket
  const { data: basket, isLoading } = useQuery({
    queryFn: () => sendGetRequest("basket", {}),
    queryKey: ["basket"],
  });

  console.log("basket", basket);

  // deleting basket item
  const basketDelete = async (id) => {
    const res = await sendPostRequest("basket/delete", {
      basketID: id,
    });
  };

  const { mutateAsync: doDeleteMutation } = useMutation({
    mutationFn: (id) => {
      return basketDelete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["basket"] });
      deletedNotyf();
    },
  });

  // loading username
  const { data: userDetails, isLoadingUser } = useQuery({
    queryFn: () => sendGetRequest("user/details", {}),
    queryKey: ["username"],
  });

  return (
    <>
      <Disclosure as="nav" className="bg-white shadow">
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 sticky top-0">
              <div className="relative flex h-16 justify-between">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Open main menu</span>
                  </Disclosure.Button>
                </div>
                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                  <div className="flex flex-shrink-0 items-center">
                    <img
                      className="h-8 w-18"
                      src={process.env.REACT_APP_LOGO}
                      alt={process.env.REACT_APP_COMPANY}
                    />
                  </div>
                  <div className="flex flex-shrink-0 items-center ml-12">
                    <img
                      className="h-8 w-18"
                      src={process.env.REACT_APP_LOGO_SECONDARY}
                      alt={process.env.REACT_APP_LOGO_SECONDARY}
                    />
                  </div>
                  <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                    <div className="inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700">
                      <Link to="/dashboard">Home</Link>
                    </div>

                    <div className="inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700">
                      <Link to="/my-orders">Orders</Link>
                    </div>

                    <div className="inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700">
                      <Link to="/address-book">Addresses</Link>
                    </div>

                    <div className="inline-flex items-center">
                      <Link
                        to="/"
                        className="z-10 px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700"
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="flex flex-1 items-center justify-center px-2 lg:ml-6 lg:justify-end">
                  <div className="w-full max-w-lg lg:max-w-xs">
                    {/* <label htmlFor="search" className="sr-only">
                      Search
                    </label> */}
                    <div className="relative">
                      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon
                          className="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </div>
                      <input
                        id="search"
                        name="search"
                        className="block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder=""
                        type="search"
                      />
                    </div>
                  </div>
                </div>

                <div className="my-5">
                  <span
                    className="ml-4 text-sm font-semibold leading-6 text-gray-900"
                    aria-hidden="true"
                  >
                    {userDetails?.userDetails[0]?.firstName
                      ? userDetails?.userDetails[0]?.firstName
                      : ""}{" "}
                    {userDetails?.userDetails[0]?.lastName
                      ? userDetails?.userDetails[0]?.lastName
                      : ""}
                  </span>
                </div>

                <div className="my-5 ml-4 flow-root lg:ml-6">
                  <a
                    href="#"
                    className="group -m-2 flex items-center p-2"
                    onClick={() => setOpen(true)}
                  >
                    <ShoppingBagIcon
                      className="h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />

                    {basket?.basket?.length === 0 ? null : (
                      <div className="bg-red-600 rounded-full w-6 h-6 pt-1 text-center text-xs text-white">
                        {basket?.basketTotal?.[0].freq}
                      </div>
                    )}
                  </a>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 pb-4 pt-2">
                <Disclosure.Button
                  as="a"
                  href="#"
                  className="block border-l-4 border-indigo-500 bg-indigo-50 py-2 pl-3 pr-4 text-base font-medium text-indigo-700"
                >
                  Dashboard
                </Disclosure.Button>
                <Disclosure.Button
                  as="a"
                  href="/Login"
                  className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700"
                >
                  Team
                </Disclosure.Button>
                <Disclosure.Button
                  as="a"
                  href="#"
                  className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700"
                >
                  Projects
                </Disclosure.Button>
                <Disclosure.Button
                  as="a"
                  href="#"
                  className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700"
                >
                  Calendar
                </Disclosure.Button>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-100" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                      <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-lg font-medium text-gray-900">
                            Shopping cart
                          </Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                              onClick={() => setOpen(false)}
                            >
                              <span className="sr-only">Close panel</span>
                            </button>
                          </div>
                        </div>

                        <div className="mt-8">
                          <div className="flow-root">
                            <ul
                              role="list"
                              className="-my-6 divide-y divide-gray-200"
                            >
                              {basket?.basket?.length === 0 ? (
                                <div className="flex justify-center">
                                  <p className="text-gray-500 text-sm mt-8">
                                    -- No items in cart --
                                  </p>
                                </div>
                              ) : null}

                              {basket?.basket?.map((product) => (
                                <li key={product.id} className="flex py-6">
                                  <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                    <img
                                      src={imageURL + product.image}
                                      className="h-full w-full object-cover object-center"
                                    />
                                  </div>

                                  <div className="ml-4 flex flex-1 flex-col">
                                    <div>
                                      <div className="flex justify-between text-base font-medium text-gray-900">
                                        <h3>{product.description}</h3>
                                      </div>
                                      <div className="flex justify-between text-base font-medium text-gray-900">
                                        <h3>{product.productCode}</h3>
                                      </div>
                                      <p className="mt-1 text-sm text-gray-500">
                                        Unit Price: $
                                        {(
                                          Math.round(product.unitPrice * 100) /
                                          100
                                        ).toFixed(2)}
                                      </p>

                                      {process.env.REACT_APP_ACCOUNT_ID ===
                                      "2" ? (
                                        <p className="mt-1 text-sm text-gray-500">
                                          Handling Fee: ${product.price2}
                                        </p>
                                      ) : null}
                                      <p className="mt-1 text-sm text-gray-500">
                                        Total Price: $
                                        {(
                                          Math.round(
                                            product.unitPrice *
                                              product.quantity *
                                              100
                                          ) / 100
                                        ).toFixed(2)}
                                      </p>
                                    </div>
                                    <div className="flex flex-1 items-end justify-between text-sm">
                                      <p className="text-gray-500">
                                        Qty {product.quantity}
                                      </p>

                                      <div className="flex">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            doDeleteMutation(product.basketID)
                                          }
                                          className="font-medium text-indigo-600 hover:text-indigo-500"
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      {basket?.basket?.length === 0 ? null : (
                        <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
                          <div className="flex justify-between text-base font-medium text-gray-900">
                            <p>Subtotal</p>
                            <p>${sumChargeTotal()}</p>
                          </div>
                          <p className="mt-0.5 text-sm text-gray-500">
                            Shipping and taxes calculated at checkout.
                          </p>
                          <div className="mt-6">
                            <a
                              href="#"
                              className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
                            >
                              <Link to="/checkout">Checkout</Link>
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default Navbar;
